import { useEffect, useState } from "react";
import { useNavigate } from "react-router";
import { Knopf } from "../design/Kachel";
import { Abweisung, Meldung } from "../design/Hinweis";
import { Eingang } from "../design/Ansicht";
import { usePasskeyzeremonie } from "./passkey";
import { passkeymeldung } from "./zugangsmeldungen";

const ANMELDEN = { zweck: "anmelden" };

/**
 * Anmeldung (oberflaeche.md §7): `button` „Anmelden“ (Passkey-Zeremonie), „Registrierung“, „Wiederherstellung“.
 * Zeigt keine schutzbedürftigen Daten, weder Ansprache noch Anredepronomen (§2.3). Die Optionen liegen beim Fingertipp
 * schon bereit, damit WebAuthn in der Geste startet (`Passkeyzeremonie`); jeder Fehlschlag hat seine Meldung (§9, V-20).
 */
export function Anmeldung() {
  const navigate = useNavigate();
  const zeremonie = usePasskeyzeremonie("anmeldung");
  const [laeuft, setLaeuft] = useState(false);
  const [grund, setGrund] = useState<string | null>(null);
  const [meldung, setMeldung] = useState<string | null>(null);

  useEffect(() => zeremonie.vorbereiten(ANMELDEN), [zeremonie]);

  function anmelden() {
    setLaeuft(true);
    setGrund(null);
    setMeldung(null);
    void zeremonie.ausfuehren(ANMELDEN).then((r) => {
      setLaeuft(false);
      if (r.fehler === "abgelehnt") setGrund(r.antwort.grund ?? "unzulaessige-angaben");
      else setMeldung(passkeymeldung("anmeldung", r.fehler));
    });
  }

  return (
    <Eingang name="Anmeldung" titel="Anmeldung" unter="Anmeldung mit Passkey" drei unten={(
      <>
        <Knopf symbol="passkey" art="planung" onPress={anmelden} isDisabled={laeuft}>Anmelden</Knopf>
        <Knopf symbol="einladung" art="planung-zweit" onPress={() => navigate("/registrierung")}>Registrierung</Knopf>
        <Knopf symbol="wiederherstellung" art="planung-zweit" onPress={() => navigate("/wiederherstellung")}>Wiederherstellung</Knopf>
      </>
    )}>
      <p className="erkl">Fingerabdruck, Gesicht oder Geräte-PIN genügen. Ein Passwort gibt es nicht.</p>
      <Abweisung grund={grund} />
      {meldung ? <Meldung>{meldung}</Meldung> : null}
    </Eingang>
  );
}
